import Ship from "./Ship";

export default Ship;
